import {JWTTOKEN, ACTIVE_REGION} from './userTypes'
export const getJWT = (accountInfo:any) => {
    return {
        type: JWTTOKEN,
        accountInfo: accountInfo
    }
}

export const activatedRegion = (region:any) => {
    return {
        type: ACTIVE_REGION,
        activatedRegion: region
    }
}